import { render } from "./DialogCanNotExchangeAfterDeparture.vue?vue&type=template&id=fb82c08a"
import script from "./DialogCanNotExchangeAfterDeparture.vue?vue&type=script&lang=js"
export * from "./DialogCanNotExchangeAfterDeparture.vue?vue&type=script&lang=js"
script.render = render

export default script